export default class Filters {


    constructor(el) {
        this.$el = jQuery(el);
        this.init(this.$el);
    }

    init(form) {
        jQuery(document).ready(function() {
            form.find('select').select2({
                minimumResultsForSearch: -1,
                width: 'resolve'
            });
        });
    }
}
